enum MethodOfContactTypes {
    Phone,
    SMS,
    Email,
}

export default MethodOfContactTypes;
